import React, { Component } from "react";
import UpdatedTechnical from "./updatedTechnicalSkills";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import Popup from "../../../../common/popup";
import { red } from "@material-ui/core/colors";
/**
 * Technical skills Component for displaying the skills detail.
 */
class TechnicalSkill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addBtn: false,
      updateBtn: false,
      data: [],
      primarydata:[],
      secondarydata:[],
      isOpen: false,
      deletePopupId :"",
      updateData: null,
      validid: false,
      isSecondarybutton:false,
     
    
    };
    this.openAddForm = this.openAddForm.bind(this);
    this.closeAddForm = this.closeAddForm.bind(this);
    this.openUpdateForm = this.openUpdateForm.bind(this);
    this.closeUpdateForm = this.closeUpdateForm.bind(this);
    this.getData = this.getData.bind(this);
    this.deleteAward = this.deleteAward.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.openSecondaryAddForm = this.openSecondaryAddForm.bind(this);
   this.openSecondaryUpdateForm = this.openSecondaryUpdateForm.bind(this)
   this.deletePrimaryAward = this.deletePrimaryAward.bind(this)
   this.deleteSecondaryAward = this.deleteSecondaryAward.bind(this)
   
  }

  // open add form

  openAddForm() {
    this.setState({
      updateBtn: true,
      updateData: null,
      isSecondarybutton:false
    });
  }
    openSecondaryAddForm() {
    this.setState({
      updateBtn: true,
      updateData: null,
      isSecondarybutton:true
    });

  }
  // close add form
  closeAddForm() {
    this.setState({
      addBtn: false,
    });
    this.getData();
  }
  // open update form detail
  openUpdateForm(detail) {
    this.setState({
      updateBtn: true,
      updateData: detail,
      isSecondarybutton:false
    });
  }

  openSecondaryUpdateForm(detail) {
    this.setState({
      updateBtn: true,
      updateData: detail,
      isSecondarybutton:true
    });
  }



  // close update form 
  closeUpdateForm() {
    this.setState({
      updateBtn: false,
    });
   this.state.isSecondarybutton ?this.secondaryskillFunc() : this.primaryskillFunc();
  }

  // toggle delete popup
  togglePopup(detail) {
    this.setState({
      isOpen: !this.state.isOpen,
      deletePopupId:detail
    });
  }

  componentDidMount() {
    this.getData();
    this.primaryskillFunc();
    this.secondaryskillFunc()

    
  }

  // get candidate skills
  getData() {
   
    axios
      .get(`${API_CANDIDATE}/v1/api/can-skill`, { withCredentials: true })
      .then((res) => {
        console.log(res);

        this.setState({
          data: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // get primary data
  primaryskillFunc() {
  axios
  .get(`${API_CANDIDATE}/v1/api/can-primary-skill`, { withCredentials: true })
  .then((res) => {
    console.log(res);

    this.setState({
      primarydata: res.data,
    });
  })
  .catch((err) => {
    console.log("err", err);
  });
}
  // get secondary data
  secondaryskillFunc() {
  axios
  .get(`${API_CANDIDATE}/v1/api/can-secondary-skill`, { withCredentials: true })
  .then((res) => {
    console.log(res);

    this.setState({
      secondarydata: res.data,
    });
  })
  .catch((err) => {
    console.log("err", err);
  });
}

  // delete function

  deleteAward(obj) {
    console.log("chandra", obj);
    console.log("chan", this.state.isOpen);

    if (this.state.data === undefined) {
      return;
    }
    let body = {
      id: obj,
    };

    console.log(body);

    axios
      .delete(`${API_CANDIDATE}/v1/api/can-skill`, {
        withCredentials: true,
        data: body,
      })
      .then((res) => {
        console.log(res);
        if (res.data.ok) {
          this.getData();
          this.setState({
            isOpen: false,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }
  deletePrimaryAward(obj) {
    console.log("chandra", obj);
    console.log("chan", this.state.isOpen);

    if (this.state.data === undefined) {
      return;
    }
    let body = {
      id: obj,
    };

    console.log(body);

    axios
      .delete(`${API_CANDIDATE}/v1/api/can-primary-skill`, {
        withCredentials: true,
        data: body,
      })
      .then((res) => {
        console.log(res);
        if (res.data.ok) {
          this.primaryskillFunc();
          this.setState({
            isOpen: false,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }
  deleteSecondaryAward(obj) {
    console.log("chandra", obj);
    console.log("chan", this.state.isOpen);

    if (this.state.data === undefined) {
      return;
    }
    let body = {
      id: obj,
    };

    console.log(body);

    axios
      .delete(`${API_CANDIDATE}/v1/api/can-secondary-skill`, {
        withCredentials: true,
        data: body,
      })
      .then((res) => {
        console.log(res);
        if (res.data.ok) {
          this.secondaryskillFunc();
          this.setState({
            isOpen: false,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  render() {
    console.log(this.state.updateData)
    const { addBtn, updateBtn, data } = this.state;

    return (
      <>
      
        {!addBtn && !updateBtn ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                
              }}
              className="details-flex-main-div"
            >
              <div style={{ paddingTop: "20px", height: "60px" }}>
                <h5  style={{ fontWeight: 700,fontSize:"1.25rem" }}>  Skills </h5>
               
              </div>
              {/* <Button
                onClick={this.openAddForm}
                type="submit"
                style={{
                  background: "green",
                  marginTop: "10px",
                  color: "white",
                }}
                className="btn login-button white-text"
              >
                ADD
              </Button> */}
            </div>

            <div className="primary-div" >
              <p  style={{ fontWeight: 700 }}>&nbsp;&nbsp;&nbsp;Primary Skills</p>
              <Button
                onClick={this.openAddForm}
                
                type="submit"
                style={{
                  background: "green",
                  marginTop: "10px",
                  color: "white",
                  
                }}
                className="btn login-button white-text"
              >
                ADD
              </Button>
            </div>
            {this.state.primarydata.length !== 0 &&
              this.state.primarydata.map((detail) => (
                <div
                  key={detail.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    background: "#FFE8",
                    
                    alignItems:"center",
                                     

                    marginBottom: "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingLeft: "2rem",
                      paddingBottom: "15px",
                      width: "100%",
                      // marginTop: "20px",
                      borderRadius: "15px",
                    }}
                  >
                       <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                        
                      }}
                    >
                      <span style={{fontWeight: "500", fontSize:"0.875rem", flexBasis: "12rem" }}>
                      {detail.skillGroup}
                     
                      </span>
                      <span style={{ fontWeight: "bold", width: "40px" }}>
                        :
                      </span>
                      <span style={{  flex: 8,fontWeight: "400", fontSize:"0.75rem"   }}>
                        {detail.skill}
                       
                      </span>
                    </div>
                  

                 
                </div>
                <div>
                    <i
                      style={{ color: "green", marginRight: "10px" }}
                      className="material-icons pointer edit-btn"
                      onClick={() => this.openUpdateForm(detail)}
                    >
                      edit
                    </i>

                    <i
                      style={{ color: "red" }}
                      // style={{ marginLeft: "1230px", marginBottom: "-500px", color: "red" }}
                      onClick={()=>this.togglePopup(detail)}
                      className="material-icons pointer contact-delete-btn"
                    >
                      delete
                    </i>
                  </div>

                  {this.state.isOpen && (
                    <Popup
                      isOpenModal={this.togglePopup}
                      isOnDelete={this.deletePrimaryAward}
                      detail={this.state.deletePopupId}
                    
                    />
                  )}
                </div>

              ))}
               <div className="primary-div">
              <p style={{ fontWeight: 700 }}> &nbsp;&nbsp;&nbsp;Secondary Skills</p>
              <Button
                onClick={this.openSecondaryAddForm}
                type="submit"
                style={{
                  background: "green",
                  marginTop: "10px",
                  color: "white",
                  
                }}
                className="btn login-button white-text"
              >
                ADD
              </Button>
            </div>
            {this.state.secondarydata.length !== 0 &&
              this.state.secondarydata.map((detail) => (
                <div
                  key={detail.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    background: "#FFE8",
                    alignItems:"center",
                   

                    marginBottom: "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingLeft: "2rem",
                      paddingBottom: "15px",
                      width: "100%",
                      
                      borderRadius: "15px",
                    }}
                  >
                       <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{fontWeight: "500", fontSize:"0.875rem", flexBasis: "12rem" }}>
                      {detail.skillGroup}
                      </span>
                      <span style={{ fontWeight: "bold", width: "40px" }}>
                        :
                      </span>
                      <span style={{  flex: 8,fontWeight: "400", fontSize:"0.75rem"   }}>
                        {detail.skill}
                      </span>
                    </div>
                  

                 
                </div>
                <div>
                    <i
                      style={{ color: "green", marginRight: "10px" }}
                      className="material-icons pointer edit-btn"
                      onClick={() => this.openSecondaryUpdateForm(detail)}
                    >
                      edit
                    </i>

                    <i
                      style={{ color: "red" }}
                      // style={{ marginLeft: "1230px", marginBottom: "-500px", color: "red" }}
                      onClick={()=>this.togglePopup(detail)}
                      className="material-icons pointer contact-delete-btn"
                    >
                      delete
                    </i>
                  </div>

                  {this.state.isOpen && (
                    <Popup
                      isOpenModal={this.togglePopup}
                      isOnDelete={this.deleteSecondaryAward}
                      detail={this.state.deletePopupId}
                    
                    />
                  )}
                </div>
              ))}
          </>
        ) : null}
        {updateBtn && (
          <UpdatedTechnical
            updateDataProp={this.state.updateData}
            back={this.closeUpdateForm}
            data={data}
            isSecondarybutton={this.state.isSecondarybutton}
          />
        )}
      </>
    );
  }
}

export default TechnicalSkill;
